export const setHasInclude = (set: Set<any>, val: any) => Boolean(set?.has(val)) 